import { IAddress, IPostalZone } from '@packlink/packlink-sdk';

export enum PlaceOrigin {
    FROM = 'FROM',
    TO = 'TO',
}

export interface IPostalCodeDropdownItem {
    label: string;
    value: {
        city: string;
        state: string;
        zipCode: string;
    };
}

export interface ICountryDropdownItem {
    label: string;
    value: IPostalZone;
}

export interface IAddressFormFields extends IAddress {
    location: IPostalCodeDropdownItem;
    postalZone: ICountryDropdownItem;
}
